<template>
  <el-tabs v-model="activateName" type="card" @tab-remove="removeTab" @tab-click="clickTab">
    <el-tab-pane v-for="(item) in menuDatas" :closable="item.isClose" :key="item.name" :label="item.title" :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import bus from "@/script/core/util/Bus";
import { MenuData } from "@/script/core/base/MenuData";

@Options({})
export default class Tabs extends Vue {
  private activateName = "index";

  private menuDatas: MenuData[] = [];

  created() {
    const self = this;
    bus.on("menu-select", (data) => {
      const menuData = data as MenuData;
      self.addTab(menuData);
    });
    bus.on("to-detail", (data) => {
      const menuData = data as MenuData;
      self.updatePath(menuData);
      self.saveToSession();
    });
    bus.on("goback-list", (data) => {
      const menuData = data as MenuData;
      self.updatePath(menuData);
      self.saveToSession();
    });
    this.initTabs();
  }

  initTabs() {
    const tabs = sessionStorage.getItem("tabs");
    if (tabs) {
      const newTabs = JSON.parse(tabs);
      newTabs.forEach((tab: any, index: any) => {
        this.menuDatas.push(tab);
      });

      this.menuDatas.forEach((tab, index) => {
        // this.toView(tab.name);
      });
    } else {
      const indexMenu: MenuData = {
        name: "/index",
        path: "/index",
        title: "首页",
        isClose: false,
      };
      this.menuDatas.push(indexMenu);
    }

    const activateName = sessionStorage.getItem("activateName");
    if (activateName) {
      this.activateName = activateName;
      this.toView(activateName);
    } else {
      this.activateName = "/index";
      this.toView(this.activateName);
    }
  }

  clickTab(data: any) {
    this.toView(data.props.name);
    this.saveToSession();
  }

  addTab(data: MenuData) {
    const currName = String(data.name);

    let exist = false;
    this.menuDatas.forEach((tab, index) => {
      if (tab.name === currName) {
        exist = true;
      }
    });
    if (exist) {
      this.activateName = currName;
      return;
    }

    this.menuDatas.push({
      name: currName,
      path: String(data.path),
      title: String(data.title),
      query: data.query,
      isClose: true,
    });
    this.activateName = currName;

    this.saveToSession();
  }

  removeTab(targetName: string) {
    const tabs = this.menuDatas;
    let activeName = this.activateName;
    if (this.activateName === targetName) {
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          const nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            activeName = nextTab.name;
          }
        }
      });
    }

    this.menuDatas = tabs.filter((tab) => tab.name !== targetName);
    this.activateName = activeName;
    this.toView(this.activateName);
    this.saveToSession();
  }

  saveToSession() {
    const menuDatastr = JSON.stringify(this.menuDatas);
    sessionStorage.setItem("tabs", menuDatastr);
    sessionStorage.setItem("activateName", this.activateName);
  }

  toView(name: string) {
    const self = this;
    this.menuDatas.forEach((tab, index) => {
      if (tab.name === name) {
        self.$router.push({
          path: tab.path,
          query: tab.query,
        });
      }
    });
    bus.emit("tab-active", name);
  } 

  updatePath(data: MenuData) {
    const self = this;
    this.menuDatas.forEach((tab, index) => {
      if (tab.name === data.name) {
        tab.path = data.path;
        tab.query = data.query;
      }
    });
  }
}
</script>
